import React, { useState } from 'react'
import { ChevronDown } from 'lucide-react'

const ToolCard = ({
	title,
	description,
	icon,
	children,
	defaultOpen = false,
}) => {
	const [isOpen, setIsOpen] = useState(defaultOpen)

	const toggleOpen = () => setIsOpen(!isOpen)

	const styles = {
		widget: {
			backgroundColor: 'white',
			borderRadius: '12px',
			boxShadow: '0 2px 8px rgba(0, 0, 0, 0.07)',
			overflow: 'hidden',
			border: '1px solid #e5e7eb',
		},
		header: {
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'space-between',
			padding: '1rem 1.5rem',
			cursor: 'pointer',
			borderBottom: isOpen ? '1px solid #e5e7eb' : 'none',
		},
		headerContent: {
			display: 'flex',
			alignItems: 'center',
			gap: '1rem',
		},
		title: {
			fontSize: '1.25rem',
			fontWeight: 600,
			color: '#1f2937',
			margin: 0,
		},
		description: {
			fontSize: '0.875rem',
			color: '#6b7280',
			margin: '0.25rem 0 0 0',
		},
		chevron: {
			transition: 'transform 0.2s ease-in-out',
			transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
			color: '#6b7280',
		},
		body: {
			padding: '1.5rem',
			backgroundColor: '#fdfdfd',
		},
	}

	return (
		<div style={styles.widget}>
			<div style={styles.header} onClick={toggleOpen}>
				<div style={styles.headerContent}>
					{icon}
					<div>
						<h2 style={styles.title}>{title}</h2>
						<p style={styles.description}>{description}</p>
					</div>
				</div>
				<ChevronDown size={24} style={styles.chevron} />
			</div>
			{isOpen && <div style={styles.body}>{children}</div>}
		</div>
	)
}

export default ToolCard
